import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Stack,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  ListItemButton,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

export default function Navigation({ isMobile, mobileOpen, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const navItems = [
    { to: "/timer", label: "Timer" },
    { to: "/stopwatch", label: "Stopwatch" },
    { to: "/pi-challenge", label: "Pi Challenge" },
    { to: "/blog", label: "Blog" },
    { to: "/sponsorship", label: "Sponsorship" },
    ...(!user
      ? [
          { to: "/login", label: "Login" },
          { to: "/signup", label: "Sign Up" },
        ]
      : [
          { to: "/dashboard", label: "Dashboard" },
          { onClick: handleLogout, label: "Logout" },
        ]),
  ];

  const content = (
    <List>
      {navItems.map((item) => (
        <ListItem key={item.label} disablePadding>
          <ListItemButton
            component={item.to ? Link : "div"}
            to={item.to}
            onClick={item.onClick || onClose}
            sx={{
              color: theme.palette.text.primary,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <ListItemText primary={item.label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 240,
          },
        }}
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ display: { xs: "none", md: "flex" } }}
    >
      {navItems.map((item) => (
        <Button
          key={item.label}
          component={item.to ? Link : "div"}
          to={item.to}
          onClick={item.onClick}
          color="inherit"
        >
          {item.label}
        </Button>
      ))}
    </Stack>
  );
}
